import React from "react";
import { createRoot } from "react-dom/client";
import Partners from "./Partners";

declare global {
	interface Window {
		renderDataStorePartnersPage: unknown;
	}
}

export function renderDataStorePartnersPage(rootId: string) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(<Partners />);
}

window.renderDataStorePartnersPage = renderDataStorePartnersPage;
